import type { ChangelogEntry } from "../types";

/**
 * Fakturaer som PowerOffice nektet å sende ble liggende som stille utkast i Go.
 * Dialogen henter nå feltene fra prosjekt og kunde, sier fra før sending, og
 * forklarer tydelig når sending feiler. Kreditnota er alltid negativ, og
 * betalingsfrist, beskrivelse og «Vår ref.» når faktisk fram til PowerOffice.
 */
export const FAKTURA_SENDING_2026_10: ChangelogEntry = {
  id: "2026-10-23-faktura-sending",
  date: "2026-10-23",
  title: "Fakturadialogen sier fra når noe mangler",
  summary:
    "Referanser og faktura-e-post hentes fra prosjekt og kunde, mangler markeres før sending, og en faktura som ikke blir sendt forklarer hvorfor.",
  sections: [
    {
      heading: "Fakturering",
      minRole: "user",
      items: [
        {
          title: "Feltene fylles fra prosjektkortet, med kundekortet som reserve",
          kind: "nytt",
          body: "Deres ref., Deres ref. kode, betalingsfrist og faktura-e-post forhåndsutfylles fra prosjektets faktureringsdetaljer. Er de tomme der, brukes kontaktperson og faktura-e-post fra kundekortet. Det står ved feltet hvor verdien kom fra.",
        },
        {
          title: "Røde og gule felt før du sender",
          kind: "nytt",
          body: "Mangler e-post og du har valgt «PDF på epost», blir feltet rødt og knappen låst til du har fylt inn. Mangler Deres ref., Deres ref. kode eller betalingsfrist, blir feltet gult med beskjed om hvor det fylles ut.",
        },
        {
          title: "En faktura som ikke ble sendt forklarer hvorfor",
          kind: "rettet",
          body: "Nektet PowerOffice å sende, lukket dialogen seg med en liten melding som var lett å overse, og fakturaen ble liggende som utkast i Go. Nå holdes dialogen åpen med forklaring på hva som mangler, og utkastet får merket «Ikke sendt» i fakturalisten. Fakturaen sendes nå alltid til kundens faktura-e-post når prosjektet ikke har en egen.",
        },
        {
          title: "Kreditnota er alltid et minusbeløp",
          kind: "rettet",
          body: "Velger du «Kreditnota» i dialogen vises summen negativt, uansett om du skriver beløpet med eller uten minus. PowerOffice får alltid en kreditnota, ikke en ny faktura.",
        },
        {
          title: "Kreditert oppstartsfaktura kan sendes på nytt",
          kind: "rettet",
          body: "Krediterer du en oppstartsfaktura fullt ut, for eksempel fordi kontraktssummen var feil, regnet Revehiet den fortsatt som sendt, og knappen for ny oppstartsfaktura var borte. Nå nullstilles leddet: oppstartsfakturaen kan lages på nytt, og faktureringsplanen låser ikke lenger det leddet. Det samme gjelder mellomfakturaer. En delvis kreditert faktura regnes fortsatt som sendt.",
        },
        {
          title: "Betalingsfrist, beskrivelse og «Vår ref.» kommer med på fakturaen",
          kind: "rettet",
          body: "Betalingsfristen fra dialogen nådde ikke PowerOffice, og beskrivelsen forsvant. Nå settes fristen på fakturaen, beskrivelsen står som første tekstlinje, og «Vår ref.» blir den som fakturerer, forutsatt at samme e-post er registrert på den ansatte i PowerOffice.",
        },
      ],
    },
  ],
};
